module.exports = __webpack_public_path__ + "static/media/pic5.c894d16f.jpg";